import { put } from 'redux-saga/effects'
import { fetchCompanyDetailsAction } from '../../actions'
import { fetchCampaignById } from '../_http/company'
import { FetchCampaignByIdResponse } from '@/redux/campaign/sagas/_http/campaign'

export function* fetchCompanyDetailsSaga(action: ReturnType<typeof fetchCompanyDetailsAction.request>) {
  const { companyId } = action.payload
  try {
    const response: FetchCampaignByIdResponse = yield fetchCampaignById({ campaignId: companyId })
    yield put(fetchCompanyDetailsAction.success({ company: response.campaign }))
  } catch (error) {
    yield put(fetchCompanyDetailsAction.failure())
  }
}
